export function formatUnixTimestampCheck() {
  return "expected unix timestamp to be a finite Float64 in the safe integer range";
}
